import Controller from '../abstracts/Controller';
import 'scss-templates/t-listing.scss';

export default class ListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'PriceRangeComponent',
      'SearchComponent',
      'PaginationComponent',
      'SeoTextComponent',
      'SimpleBarComponent',
      'GeneralComponentsComponent',
      'WishlistComponent',
      'AddToWishlistComponent',
      'VisualMerchandaisingComponent',
      'HistoryManagerComponent',
      'CategoryFilterComponent',
      'ShopCategoryComponent',
      'ListingShortcutsComponent',
    ];
  }
}
